export enum ChangesStatus {
	New = 'new',
	Modified = 'modified',
	Deleted = 'deleted',
	ChildrenReorder = 'reorder'
}
